/**
 * Design tokens — single source of truth is `frontend/design/tokens.json`.
 * Runtime values are generated into `./tokens.generated.js`.
 * Tailwind palette/fonts/z-index/motion read the same JSON file.
 */

import { RADIUS } from './tokens.generated';

export const radius = {
  sm: RADIUS.sm.class,
  md: RADIUS.md.class,
  lg: RADIUS.lg.class,
};

export const radiusValue = {
  sm: RADIUS.sm.value,
  md: RADIUS.md.value,
  lg: RADIUS.lg.value,
};

export const focusRing =
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400/70 focus-visible:ring-offset-2 ';

export const transition =
  'transition-[color,background-color,border-color,box-shadow,transform] duration-hover ease-out-strong';

export const surface = {
  field:
    'border border-secondary-200/60 bg-white/80 text-secondary-900 shadow-[inset_0_1px_0_rgba(255,255,255,0.6)] backdrop-blur-md   ',
  fieldFocus:
    'focus:border-orange-300/80 focus:bg-white focus:ring-2 focus:ring-orange-400/25 focus:shadow-soft   ',
  panel:
    'border border-secondary-200/50 bg-white/60 shadow-[inset_0_1px_0_rgba(255,255,255,0.55)] backdrop-blur-md  ',
};

export const typography = {
  eyebrow: 'eyebrow',
  sectionTitle: 'section-title',
  statLabel: 'stat-label',
  formLabel: 'form-label',
};

export const layout = {
  container: 'container-premium',
  contentFlow: 'content-flow',
  sectionPadding: 'section-padding',
};
